import { createUseStyles } from 'react-jss';
import { colors } from '../../constants/colors';
import {breakpoints} from "../../constants/breakpoints";

const styles = createUseStyles((theme) => ({
  escalation: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  escalationContainer: {
    maxWidth:"380px",
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    height: '100%',
    marginTop: "24px",
    marginBottom:"32px",
    padding: "0px 10px"
  },
  title: {
    textAlign: "center",
    fontSize: '30px',
    fontWeight: '600',
    lineHeight: '38px',
    color: colors.lightBlack,
    marginBottom: '12px',
  },
  description: {
    textAlign: "center",
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '24px',
    color: colors.mediumGrey,
  },
  formContainer:{
    width:"360px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width:"300px",
    }
  },
  inputContainer:{
    marginBottom:"20px",
    display:"flex",
    flexDirection:"column",
    "& input":{
      height: "44px",
      width: "100%",
      border: "1px solid " + colors.darkGrey,
      borderRadius: "8px",
      padding: "10px 14px",
      "&:focus": {
        outline: "none"
      }
    },
    "& input[disabled]":{
      color: colors.inactiveGrey,
      backgroundColor: colors.brightBlue,
      '-webkit-text-fill-color': colors.inactiveGrey,
      opacity: 1,
    },
    "& .input-error":{
      border: "1px solid " + colors.red,
      backgroundSize: "16px 16px",
      backgroundPosition: "right",
      backgroundRepeat: "no-repeat",
      backgroundOrigin:"content-box",
      // backgroundImage: `url(${checkIconRed})`
    },
  },
  label:{
    fontSize: "14px",
    fontWeight:"500",
    lineHeight:"20px",
    color: colors.grey,
    marginBottom:"6px",
    display: "flex"
  },
  btnContainer:{
    margin: "24px 0px"
  },
  saveBtn: {
    padding:"10px 37.5px",
    width:"100%",
    display:"flex",
    justifyContent:"center",
    textAlign:"center",
    borderRadius:"8px",
    fontSize: "16px",
    fontWeight:"600",
    lineHeight:"24px",
  },
  inputMargin: {
    marginBottom:"18px"
  },
  inputContainerMembership:{
    marginBottom:"20px",
    display:"flex",
    flexDirection:"column",
    "& div": {
      "& svg": {
        margin: "auto 10px auto 0px",
      },
      display: "flex",
      backgroundColor: colors.brightBlue,
      border: "1px solid " + colors.darkGrey,
      borderRadius: "8px",
      height: "44px",
      padding: "10px 14px",
    },
    "& input":{
      border: "none",
      padding: "0px",
      "&:focus": {
        outline: "none"
      }
    },
    "& input[disabled]":{
      color: colors.inactiveGrey,
      backgroundColor: colors.brightBlue,
      '-webkit-text-fill-color': colors.inactiveGrey,
    },
  },
  roles: {
    textAlign:"left",
    height:"44px",
  },
  questionInputContainer:{
    marginBottom:"24px",
    display:"flex",
    flexDirection:"column",
    flexWrap:"wrap",
    alignContent:"flex-start",
    overflow:"auto",
    "& textarea":{
      height: "164px",
      width: "100%",
      border: "1px solid " + colors.darkGrey,
      borderRadius: "8px",
      padding: "10px 14px",
      display: "flex",
      "&:focus": {
        outline: "none"
      },
    },
    "& .input-error":{
      border: "1px solid " + colors.red,
      backgroundSize: "16px 16px",
      backgroundPosition: "right",
      backgroundRepeat: "no-repeat",
      backgroundOrigin:"content-box",
      // backgroundImage: `url(${checkIconRed})`
    },
  },
  error: {
    color: colors.red,
    fontSize: "14px",
    textAlign: "left",
    "& p": {
      margin: 0,
    }
  },

}));

export default styles;
